import {isEmptyOrNull, isNullOrUndefined} from "../common/NamaCommon";
import {currentTimeMillis} from "./ClientCache";
import {isCurrentLogInInfoValid, logout, user} from "./Security";
import {currentLoginInfo} from "./LoginPresenter";
import * as notifier from "../common/ErrorsNotification";
import {translateId} from "../common/Translator";
import * as app from "../views/mainapp";
import {NamaRouterInstance} from "../routing/NamaRouter";

let registered = false;

function onActivity() {
    localStorage.setItem("nlsat", currentTimeMillis() + "");
}

function registerActivityEvents() {
    $(document).on("mousemove.logouttimer keypress.logouttimer touchstart.logouttimer click.logouttimer scroll.logouttimer wheel.logouttimer", (e) => onActivity());
    window.addEventListener("message", function (e) {
        let key = e.message ? "message" : "data";
        let data = e[key];
        if (data === "activityFromReport") {
            onActivity();
        }
    });
}

function unregisterEvents() {
    registered = false;
    $(document).off(".logouttimer");
}

function logoutIfNoActivity() {
    let nlsat = localStorage.getItem("nlsat");
    let lastActivityMS = currentTimeMillis() - nlsat || 0;
    if (lastActivityMS / 60000 >= currentLoginInfo().autoLogoutTime) {
        notifier.showError(translateId("autoLogoutHappened"));
        logout();
    }
}

export function registerLoginLogoutEvents() {
    $(window).on('storage', (e) => {
        let currentLogInInfoValid = isCurrentLogInInfoValid();
        if (e.key === 'lastlogintimestamp' || (e.originalEvent && e.originalEvent.key === 'lastlogintimestamp')) {
            if (!currentLogInInfoValid)
                app.instance.loginPresenter.login();
        } else if (e.key === 'lastlogouttimestamp' || (e.originalEvent && e.originalEvent.key === 'lastlogouttimestamp')) {
            if (currentLogInInfoValid)
                logout();
        }
    });
    $(window).on('beforeunload', (e) => {
        let presenter = NamaRouterInstance.currentPresenter;
        $(':focus').blur();
        if (presenter && presenter.hasChanges && presenter.hasChanges())
            return "";
    });
}

export function registerIfNeeded(info) {
    if (registered)
        return;
    if (isEmptyOrNull(info.autoLogoutTime))
        return;
    if ((isNullOrUndefined((info.autoLogoutRememberMe)) || info.autoLogoutRememberMe === false) &&
        localStorage.getItem("rememberme") === true)
        return;
    localStorage.setItem("nlsat", currentTimeMillis() + "");
    registered = true;
    registerActivityEvents();
    let t = () => {
        if (isNullOrUndefined(user()) || isEmptyOrNull(currentLoginInfo().autoLogoutTime)) {
            unregisterEvents();
            return false;
        }
        logoutIfNoActivity();
        setTimeout(t, 3000);
        return true;
    };
    t();
}